import { FormEvent, useContext, useState } from "react";
import { Button, Loader } from "../Styles";
import { PropsEtapaProjeto } from "../../interfaces/projetos";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { toast } from "react-toastify";
import { atualizarEtapaController, cadastrarEtapa } from "../../services/projetos";
import { criptografarDado } from "../../helpers";
import "./index.css"
import { useLocation } from 'react-router-dom';

function ModalEtapaProjetos({ etapa }: PropsEtapaProjeto) {
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)
  const [processando, setProcessando] = useState(false);
  
  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");

  const [nomeEtapa, setNomeEtapa] = useState<string>();

  const cadastrarEtapaProjeto = async (e: FormEvent) => {
    e.preventDefault()

    if (!idProjeto) return toast.error("Projeto não encontrado")
    if (!nomeEtapa) return toast.info("Preencha os Campos Necessários")
    setProcessando(true)
    try {
      const payload = {
        idProjeto,
        etapa: nomeEtapa
      }
      const resposta = await cadastrarEtapa(payload)

      if (resposta.status === 201) {
        toast.success("Etapa Cadastrada com Sucesso.")
        setProcessando(false)
        atualizarDados()
        modalExibir("")
      }
    } catch (error) {
      toast.error("Erro ao Cadastrar Etapa")
    }
  }

  const atualizarEtapa = async (e: FormEvent, idEtapa: string) => {
    e.preventDefault()
    if (!idProjeto) return toast.error("Projeto não encontrado")
    setProcessando(true)
    try {
      const idEtapaCript = criptografarDado(idEtapa)
      const payload = {
        idProjeto: idProjeto,
        etapa: nomeEtapa,
      }

      const resposta = await atualizarEtapaController(idEtapaCript, payload)

      if (resposta.status === 200) {
        toast.success("Etapa Atualizada com Sucesso.")
        setProcessando(false)
        atualizarDados()
        modalExibir("")
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Atualizar Etapa")
    }
  }

  return (
    <div id='fundoModal'>
      <section className={'containerModalCentro'}>
        <span className='novoContainerTitulo'>
          <h1>{etapa ? "Atualizar Etapa" : "Cadastrar Etapa"}</h1>
        </span>

        <form
          action=""
          onSubmit={(e) => (etapa ? atualizarEtapa(e, etapa.id.toString()) : cadastrarEtapaProjeto(e))}
        >
          <section className="etapa-projeto-input-container">
            <span>
              <input
                type="text"
                placeholder="Nome da Etapa"
                className="etapa-projeto-input"
                onChange={(e) => setNomeEtapa(e.target.value)}
                maxLength={100}
                required={!etapa}
                defaultValue={etapa?.etapa}
              />
            </span>
          </section>
          <span className="botoes-footer">
            <Button type="button" cor="cancelar" isLoading={processando} onClick={() => modalExibir("")}>
              Cancelar
            </Button>
            <Button type="submit" cor="salvar" isLoading={processando}>
              {!processando && "Salvar"}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section>
    </div >
  );
}

export default ModalEtapaProjetos;